<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <!-- track -->
    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a
            class="linkstyle"
            href="https://www.chanchao.com.tw/ExhibitorServiceTW/"
            >展覽列表</a
          ><span>/</span> <em name="Exhibition">{{ ExhibitionName }}</em
          ><span>/</span><span name="directoryTitle"></span>
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="MbDevice">
        <div class="homeLeft">
          <div class="UserAccount ml-1">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo">
            <img :src="ExhLogo" width="100%" />
          </div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition">{{ ExhibitionName }}</p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ ExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>

      <div class="contentBox">
        <h1><span name="directoryTitle"></span></h1>
        <p class="my-3">&nbsp;</p>
        <!-- 未截止表單形式 -->
        <div v-if="openDirectory == '0'">
          <div class="alert" style="font-size: 15px">
            本展會目前未開放會刊登錄功能。
          </div>
        </div>
        <div v-else-if="openDirectory == '1'">
          <div class="alert">
            <div class="HasDirectory" v-if="!DirectoryHardcopy">
              <p>
                大會將於<span class="red"> {{ directoryListDeadline }} </span>
                結束登錄功能，將依您所填寫的內容刊登於展覽大會專刊，未填寫將視為放棄刊登，<span
                  class="gray mb-3"
                  >若要修改公司名稱、電話、傳真，請<a
                    href="//www.chanchao.com.tw/contact.asp"
                    target="_blank"
                    >聯繫主辦單位</a
                  >。
                </span>
              </p>
            </div>
            <p class="mt-1">
              以下資料( 公司名稱、網址、廠商/產品介紹
              )將露出於官網->參展商列表。
            </p>
          </div>
          <p class="my-3">&nbsp;</p>
          <!-- 測試方法，將截止日期改為未到期，按鈕將兩個條件都改成相反，即可出現按鈕表格 -->
          <div v-if="!dateExpired">
            <table class="table w-100 mt-5 table-bordered">
              <thead class="thead-dark">
                <tr>
                  <th class="text-center h5">
                    <span name="homeDirectoryTitle"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <form
                      name="thisform"
                      id="form"
                      class="mx-3"
                      @submit.prevent="submitform"
                    >
                      <input type="hidden" name="RegNo" />
                      <!-- 未登錄且有歷史資料則顯示按鈕 -->
                      <div id="HistoryDir" v-if="analHistory">
                        您有歷史會刊資料，請點此
                        <button
                          class="ml-2 mb-1 btn btn-primary"
                          @click.prevent="OpenCopyModal"
                        >
                          複製歷屆資料
                        </button>
                        <p class="red mt-2 h4" v-if="alertSubmit">
                          *請確認帶入的歷屆資料無誤，並按下『確定送出』按鈕才算完成登錄。
                        </p>
                      </div>
                      <h3 name="Directory_ComName" class="mt-4">
                        {{ Directory_ComName }}
                      </h3>
                      <input type="hidden" name="ComName" />
                      <p name="Directory_eComName">{{ Directory_eComName }}</p>
                      <input type="hidden" name="eComName" />
                      <p class="divider"></p>

                      <div class="my-2">
                        <p class="formTitle">電話</p>
                        <p>{{ RegTel }}</p>
                        <p class="formTitle mt-2">Fax</p>
                        <p>{{ RegFax }}</p>
                      </div>

                      <p class="my-3">&nbsp;</p>

                      <p class="formTitle">
                        國家/地區 <span class="red">*</span>
                      </p>
                      <div class="langTip mb-3" style="width: 180px">
                        <select
                          class="form-control text-dark"
                          v-model="directoryList.CountryCode"
                          required
                        >
                          <option value="">-- 請選擇 --</option>
                          <optgroup label="Common Countries">
                            <option
                              v-for="item in CountryListCommon"
                              :key="item.Country_Code"
                              :value="item.Country_Code"
                            >
                              {{ item.eCountry }} {{ item.Country }}
                            </option>
                          </optgroup>

                          <optgroup label="Other Countries">
                            <option
                              v-for="item in CountryListOther"
                              :key="item.Country_Code"
                              :value="item.Country_Code"
                            >
                              {{ item.eCountry }} {{ item.Country }}
                            </option>
                          </optgroup>
                        </select>
                      </div>
                      <p class="my-3">&nbsp;</p>

                      <p class="formTitle">
                        郵遞區號 <span class="red">*</span>
                      </p>
                      <input
                        type="text"
                        name="ComPostalcode"
                        v-model="directoryList.ComPostalcode"
                        class="codeText textStyle"
                        maxlength="10"
                        required
                      />

                      <p class="my-3">&nbsp;</p>

                      <p class="formTitle">地址 <span class="red">*</span></p>

                      <div class="langTip">
                        <input
                          type="text"
                          name="eComAddress"
                          v-model="directoryList.eComAddress"
                          class="maxText textStyle"
                          maxlength="200"
                          required
                        />
                        <span>EN</span>
                      </div>

                      <div v-if="!isOverseas">
                        <p class="divider"></p>
                        <div class="langTip">
                          <input
                            type="text"
                            name="ComAddress"
                            v-model="directoryList.ComAddress"
                            class="maxText textStyle"
                            maxlength="200"
                            required
                          />
                          <span>中</span>
                        </div>
                      </div>

                      <p class="my-3">&nbsp;</p>
                      <div class="left">
                        <p class="formTitle">
                          Email <span class="red">*</span>
                        </p>
                        <input
                          type="text"
                          name="ComEmail"
                          v-model="directoryList.ComEmail"
                          class="maxText textStyle"
                          maxlength="100"
                          required
                        />

                        <p class="grayBG mt-2">
                          如需輸入兩組以上的 Email，請用分號( ; )隔開，例 :
                          chanchao@gmail.com;exhibitorTW@gmail.com
                        </p>
                        {{ anaText }}
                        <div v-if="alertMail">
                          <span style="font-size: 13px; color: #e42212"
                            >Email 欄位請勿含有特殊字元！</span
                          >
                        </div>
                      </div>

                      <div class="right">
                        <p class="formTitle">網址</p>
                        <input
                          type="text"
                          name="ComWebsite"
                          v-model="directoryList.ComWebsite"
                          class="maxText textStyle"
                          maxlength="100"
                        />
                        <p class="grayBG mt-2">
                          請務必加上http 或https 以免無法開啟連結
                        </p>
                      </div>
                      <p class="clear">&nbsp;</p>
                      <p class="my-3">&nbsp;</p>

                      <div v-if="!isOverseas">
                        <p class="formTitle">
                          廠商/產品介紹 (中) <span class="red">*</span>
                        </p>
                        <div>
                          <textarea
                            name="Product"
                            rows="8"
                            class="maxText textStyle"
                            v-model="directoryList.Product"
                            @input="countNums"
                            required
                            placeholder="中文"
                          ></textarea>
                          <p class="divider"></p>

                          <p class="blueBG" v-if="cnWdNum">
                            字數限制 {{ DirectoryProductLimit }} 字元 (
                            1個中文字為2個字元 )<span v-if="ExtraWdNum !== 0"
                              >，
                              <span>剩餘可輸入 {{ ExtraWdNum }} 字元 </span>
                            </span>
                          </p>
                          <p class="redBG" v-else>
                            * 請刪減至
                            {{ DirectoryProductLimit }} 字元以下，目前已超出
                            {{ ExtraWdNum }} 字
                          </p>
                        </div>
                        <p class="my-3">&nbsp;</p>
                      </div>

                      <p class="formTitle">
                        廠商/產品介紹 (English) <span class="red">*</span>
                      </p>
                      <div>
                        <textarea
                          name="eProduct"
                          rows="8"
                          class="maxText textStyle"
                          v-model="directoryList.eProduct"
                          @input="ecountNums"
                          required
                          placeholder="English"
                        ></textarea>
                        <p class="divider"></p>

                        <p class="blueBG" v-if="enWdNum">
                          字數限制 {{ eDirectoryProductLimit }} 字元<span
                            v-if="eExtraWdNum !== 0"
                            >，
                            <span>剩餘可輸入 {{ eExtraWdNum }} 字元 </span>
                          </span>
                        </p>
                        <p class="redBG" v-else>
                          * 請刪減至
                          {{ eDirectoryProductLimit }} 字元以下，目前已超出
                          {{ eExtraWdNum }} 字
                        </p>
                      </div>
                      <p class="my-3">&nbsp;</p>

                      <div class="text-center mb-3">
                        <input
                          type="submit"
                          value="確定送出"
                          class="btn btn-primary py-2 px-4"
                        />
                      </div>
                    </form>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="mt-5" v-if="isOverseas">
              <table class="table table-bordered w-100">
                <thead class="thead-light">
                  <tr>
                    <th colspan="3" class="text-center bg-dark text-white h5">
                      代理資訊
                    </th>
                  </tr>
                  <tr v-if="DirectoryOrgList.length > 0">
                    <th class="text-center" style="width: 5%">No.</th>
                    <th class="text-center" style="width: 30%">內容</th>
                    <th class="text-center" style="width: 5%">管理</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, index) in DirectoryOrgList" :key="item.id">
                    <td class="text-center align-middle">{{ index + 1 }}.</td>
                    <td>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-2">
                            <span class="bold">公司屬性:</span>
                            {{ item.Checked }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">公司名稱:</span>
                            {{ item.Name }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">國家:</span>
                            {{ item.Country }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">地址:</span>
                            {{ item.Address }}
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-2">
                            <span class="bold">電話:</span>
                            {{ item.Tel }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">郵遞區號:</span>
                            {{ item.Postalcode }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">Email:</span>
                            {{ item.Email }}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td class="text-center align-middle">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click.prevent="deleteDirectoryOrg(item.id)"
                      >
                        刪除
                      </button>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="3" class="text-center">
                      <div
                        class="btn btn-primary mt-3 py-2 px-4"
                        @click="OpenAgencyModal"
                        v-if="analLogin"
                      >
                        新增
                      </div>

                      <div v-else>
                        <div class="btn btn-primary mt-3 py-2 px-4 disabled">
                          新增
                        </div>
                        <div class="mt-2 red">
                          *新增代理資訊前，請先完成會刊登錄流程。
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 截止後形式 -->
          <div v-if="dateExpired">
            <table class="table w-100 mt-5 table-bordered">
              <thead class="thead-dark">
                <tr>
                  <th class="text-center h5">
                    <span name="homeDirectoryTitle"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <p class="formTitle mb-2">公司名稱</p>
                    <p>{{ directoryList.Directory_ComName }}</p>
                    <p>{{ directoryList.Directory_eComName }}</p>
                    <p class="my-3">&nbsp;</p>

                    <div>
                      <p class="formTitle">電話</p>
                      <p>{{ directoryList.ComTel }}</p>
                    </div>
                    <p class="my-3">&nbsp;</p>

                    <div>
                      <p v-if="directoryList.ComFax" class="formTitle mt-2">
                        傳真
                      </p>
                      <p>{{ directoryList.ComFax }}</p>
                    </div>

                    <p class="my-3">&nbsp;</p>
                    <div>
                      <p class="formTitle">
                        國家/地區 <span class="red">*</span>
                      </p>
                      <p>{{ directoryList.CountryCode }}</p>
                    </div>

                    <p class="my-3">&nbsp;</p>

                    <div>
                      <p class="formTitle">
                        郵遞區號 <span class="red">*</span>
                      </p>
                      <p>{{ directoryList.ComPostalcode }}</p>
                    </div>

                    <p class="my-3">&nbsp;</p>

                    <div class="mb-2">
                      <p class="formTitle">地址 <span class="red">*</span></p>
                      <div class="langTip" v-if="!isOverseas">
                        {{ directoryList.ComAddress }}
                      </div>
                      <div class="langTip">
                        {{ directoryList.eComAddress }}
                      </div>
                    </div>

                    <p class="my-3">&nbsp;</p>
                    <div class="mb-2">
                      <div class="left">
                        <p class="formTitle">
                          Email <span class="red">*</span>
                        </p>
                        <ul v-for="item in directoryEmail">
                          <li>{{ item }}</li>
                        </ul>
                      </div>
                      <div class="right">
                        <p class="formTitle">網址</p>
                        {{ directoryList.ComWebsite }}
                      </div>
                    </div>

                    <p class="clear">&nbsp;</p>

                    <div v-if="!isOverseas">
                      <p class="my-3">&nbsp;</p>
                      <p class="formTitle mt-2">
                        廠商/產品介紹 (中) <span class="red">*</span>
                      </p>
                      <div>
                        {{ directoryList.Product }}
                      </div>
                      <p class="my-3">&nbsp;</p>
                    </div>
                    <p class="formTitle mt-2">
                      廠商/產品介紹 (English) <span class="red">*</span>
                    </p>
                    <div>
                      {{ directoryList.eProduct }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="mt-5" v-if="isOverseas">
              <table
                class="table table-bordered w-100"
                v-if="DirectoryOrgList.length > 0"
              >
                <thead class="thead-light">
                  <tr>
                    <th colspan="3" class="text-center bg-dark text-white h5">
                      代理資訊
                    </th>
                  </tr>
                  <tr v-if="DirectoryOrgList.length > 0">
                    <th class="text-center" style="width: 5%">No.</th>
                    <th class="text-center" style="width: 30%">內容</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in DirectoryOrgList" :key="item.id">
                    <td class="text-center align-middle">{{ index + 1 }}.</td>
                    <td>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-2">
                            <span class="bold">公司屬性:</span>
                            {{ item.Checked }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">公司名稱:</span>
                            {{ item.Name }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">國家:</span>
                            {{ item.Country }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">地址:</span>
                            {{ item.Address }}
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-2">
                            <span class="bold">電話:</span>
                            {{ item.Tel }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">郵遞區號:</span>
                            {{ item.Postalcode }}
                          </div>
                          <div class="mb-2">
                            <span class="bold">Email:</span>
                            {{ item.Email }}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </article>

    <!-- Modal -->
    <div
      class="modal fade"
      id="AgencyModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div>
              <div class="modal-title h3" id="ModalLabel">
                <div class="d-flex align-items-center">
                  <img
                    src="@/assets/images/commission.png"
                    width="36px"
                    alt=""
                  />
                  <div class="ml-2">新增代理資訊</div>
                </div>
              </div>
            </div>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form @submit.prevent="submitAgency">
            <div class="modal-body">
              <div class="alert alert-light text-dark px-2" role="alert">
                <p>
                  <i class="fas fa-exclamation-circle"> </i>
                  最多以10家為限，所有資訊僅限英文填寫。
                </p>
              </div>
              <p class="my-3">&nbsp;</p>

              <p class="formTitle">公司屬性 <span class="red">*</span></p>
              <div class="langTip mb-3" style="width: 180px">
                <select
                  class="form-control text-dark"
                  v-model="optionNature"
                  required
                >
                  <option value="">-- 請選擇 --</option>
                  <option
                    v-for="(item, index) in AgencyNatureList"
                    :key="index"
                    :value="item.eNatureName"
                  >
                    {{ item.NatureName }}
                  </option>
                </select>
              </div>

              <p class="formTitle">公司名稱 <span class="red">*</span></p>
              <div class="langTip mb-3">
                <input
                  type="text"
                  class="maxText textStyle"
                  required
                  maxlength="200"
                  v-model="eCom_Name"
                  @input="(e) => filterField('eCom_Name', e)"
                  @compositionstart="isComposing = true"
                  @compositionend="(e) => handleCompositionEnd('eCom_Name', e)"
                />
                <span>EN</span>
              </div>

              <p class="formTitle">地址 <span class="red">*</span></p>
              <div class="langTip mb-3">
                <input
                  type="text"
                  class="maxText textStyle"
                  required
                  maxlength="400"
                  v-model="eCom_Address"
                  @input="(e) => filterField('eCom_Address', e)"
                  @compositionstart="isComposing = true"
                  @compositionend="
                    (e) => handleCompositionEnd('eCom_Address', e)
                  "
                />
                <span>EN</span>
              </div>

              <p class="formTitle">國家 <span class="red">*</span></p>
              <div class="langTip mb-3" style="width: 180px">
                <select
                  class="form-control text-dark"
                  v-model="optionAgencyCountry"
                  required
                >
                  <option value="">-- 請選擇 --</option>
                  <optgroup label="Common Countries">
                    <option
                      v-for="item in CountryListCommon"
                      :key="item.Country_Code"
                      :value="item.Country_Code"
                    >
                      {{ item.eCountry }} {{ item.Country }}
                    </option>
                  </optgroup>

                  <optgroup label="Other Countries">
                    <option
                      v-for="item in CountryListOther"
                      :key="item.Country_Code"
                      :value="item.Country_Code"
                    >
                      {{ item.eCountry }} {{ item.Country }}
                    </option>
                  </optgroup>
                </select>
              </div>

              <p class="formTitle">郵遞區號: <span class="red">*</span></p>
              <div class="langTip mb-3" style="width: 180px">
                <input
                  type="text"
                  class="maxText form-control"
                  inputmode="numeric"
                  required
                  maxlength="10"
                  v-model="Com_Postalcode"
                />
              </div>

              <p class="formTitle">電話: <span class="red">*</span></p>
              <div class="langTip mb-3" style="width: 80%; text-align: left">
                <div class="row">
                  <div class="col">
                    <input
                      type="tel"
                      pattern="[0-9]*"
                      class="form-control"
                      maxlength="5"
                      placeholder="Country Code"
                      v-model="Tel1"
                      required
                    />
                  </div>
                  <div>-</div>
                  <div class="col">
                    <input
                      type="tel"
                      class="form-control"
                      pattern="[0-9]*"
                      maxlength="5"
                      placeholder="Area Code"
                      v-model="Tel2"
                      required
                    />
                  </div>
                  <div>-</div>
                  <div class="col">
                    <input
                      type="tel"
                      pattern="[0-9]*"
                      class="form-control"
                      maxlength="25"
                      placeholder="Number"
                      v-model="Tel3"
                      required
                    />
                  </div>
                </div>
              </div>

              <p class="formTitle">E-mail: <span class="red">*</span></p>
              <div class="langTip mb-3" style="width: 80%">
                <input
                  type="email"
                  class="maxText form-control"
                  required
                  maxlength="100"
                  v-model="Com_Email"
                />
              </div>
            </div>

            <div class="modal-footer">
              <div class="PcDevice">
                <button
                  type="submit"
                  id="cropImageBtn"
                  class="btn btn-primary btn-lg mr-2"
                >
                  送出
                </button>
                <button
                  type="button"
                  class="btn btn-lg btn-secondary"
                  data-dismiss="modal"
                >
                  關閉
                </button>
              </div>
              <div class="MbDevice">
                <button
                  type="submit"
                  id="cropImageBtn"
                  class="btn btn-primary mr-2"
                >
                  送出
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  關閉
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="CopyModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div>
              <div class="modal-title h3" id="ModalLabel">
                <div class="d-flex align-items-center">
                  <img
                    src="@/assets/images/open-folder2.png"
                    width="36px"
                    alt=""
                  />
                  <div class="ml-2">歷屆會刊資料列表</div>
                </div>
              </div>
            </div>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="alert alert-light text-dark px-2" role="alert">
              <p>
                <i class="fas fa-exclamation-circle"> </i>
                列表顯示您兩年內所參加的展覽
              </p>
            </div>
            <p class="my-3">&nbsp;</p>

            <ul
              v-for="(item, index) in HisDirectoryList"
              :key="index"
              class="mx-5 my-3"
            >
              <li>
                <div class="row justify-content-between align-items-center">
                  <div class="col-md-9 text-md-left text-center text-md-left">
                    <div class="row align-items-center">
                      <div class="col-md-4 text-center text-md-left">
                        <img
                          :src="`//www.ccie.com.tw/exhibition/images/exlogo/${item.Logo}`"
                          class="img-fluid mb-2 mb-md-0 px-5 px-md-0"
                        />
                      </div>
                      <div class="col-md-8 text-center text-md-left">
                        <p
                          class="bold mb-1 mb-2 mb-md-0"
                          style="font-size: 17px"
                        >
                          {{ item.Exhibition }}
                        </p>
                        <span>
                          <p class="gray">
                            {{ item.ExhBegin }} ~ {{ item.ExhEnd }}
                          </p>
                          <p class="gray">{{ item.ExhVenue }}</p>
                          <p class="divider">&nbsp;</p>
                          <p>
                            <!-- <span class="colorBG">{{ item.AppNo }}</span> -->
                            {{ item.Directory_ComName }}
                          </p>
                          <p>展覽分區 : {{ item.ExhibArea }}</p>
                          <p>
                            攤位號碼 :
                            <span v-if="item.BoothNo == 'N/A'"> - </span>
                            <span v-else> {{ item.BoothNo }} </span>
                          </p>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3 text-right PcDevice">
                    <div
                      class="btn btn-lg btn-primary py-1"
                      @click.prevent="ShowDirectoryInfo(item.DirectoryId)"
                    >
                      預覽
                    </div>
                  </div>

                  <div class="col-md-3 text-center MbDevice mt-3">
                    <div
                      class="btn btn-primary"
                      @click.prevent="ShowDirectoryInfo(item.DirectoryId)"
                    >
                      預覽
                    </div>
                  </div>
                </div>
              </li>
              <hr />
            </ul>
          </div>

          <div class="modal-footer">
            <div class="text-center">
              <div class="PcDevice">
                <button
                  type="button"
                  class="btn btn-lg btn-secondary"
                  data-dismiss="modal"
                >
                  關閉
                </button>
              </div>
              <div class="MbDevice">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  關閉
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="ShowDirectoryInfoModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div>
              <div class="modal-title h3" id="ModalLabel">
                <i class="fas fa-eye mr-1"></i> 歷屆會刊資料預覽
              </div>
            </div>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="bold mt-2 mb-1" style="font-size: 18px">
              {{ DirectoryInfo.Exhibition }}
            </div>
            <div>
              <p class="gray">
                {{ DirectoryInfo.ExhBegin }} ~ {{ DirectoryInfo.ExhEnd }}
              </p>
              <p class="gray mb-2">{{ DirectoryInfo.ExhVenue }}</p>
              <p>
                <!-- <span class="colorBG">{{ DirectoryInfo.AppNo }}</span> -->
                {{ DirectoryInfo.Directory_ComName }}
              </p>
              <p>
                <!-- <span class="colorBG">{{ DirectoryInfo.AppNo }}</span> -->
                {{ DirectoryInfo.Directory_eComName }}
              </p>

              <hr />
              <!-- <div class="row mt-4 mb-2">
                <div class="col-md-6">
                  <p class="bold text-info">電話</p>
                  <p style="word-break: break-all">
                    {{ DirectoryInfo.ComTel || "-" }}
                  </p>
                </div>

                <div class="col-md-6">
                  <p class="bold text-info">Fax</p>
                  <p style="word-break: break-all">
                    {{ DirectoryInfo.ComFax || "-" }}
                  </p>
                </div>
              </div> -->

              <div class="mt-4">
                <p class="bold text-info">國家/地區</p>
                <p style="word-break: break-all">
                  {{ DirectoryInfo.CountryCode || "-" }}
                </p>
              </div>

              <div class="mt-4">
                <p class="bold text-info">郵遞區號</p>
                <p style="word-break: break-all">
                  {{ DirectoryInfo.ComPostalcode || "-" }}
                </p>
              </div>

              <div class="mt-4">
                <p class="bold text-info">地址</p>
                <p>{{ DirectoryInfo.ComAddress || "-" }}</p>
                <p>{{ DirectoryInfo.eComAddress || "-" }}</p>
              </div>

              <div class="row mt-4">
                <div class="col-md-6">
                  <p class="bold text-info">Email</p>
                  <p style="word-break: break-all">
                    {{ DirectoryInfo.ComEmail || "-" }}
                  </p>
                </div>

                <div class="col-md-6">
                  <p class="bold text-info">網址</p>
                  <p style="word-break: break-all">
                    {{ DirectoryInfo.ComWebsite || "-" }}
                  </p>
                </div>
              </div>

              <div class="mt-4 bold text-info">廠商/產品介紹 (中)</div>
              <div class="mt-1" style="white-space: pre-line">
                {{ DirectoryInfo.Product || "-" }}
              </div>

              <div class="mt-4 bold text-info">廠商/產品介紹 (English)</div>
              <div class="mt-1" style="white-space: pre-line">
                {{ DirectoryInfo.eProduct || "-" }}
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <div class="PcDevice">
              <button
                type="submit"
                id="cropImageBtn"
                class="btn btn-primary btn-lg mr-3"
                @click="getHistData(DirectoryInfo)"
              >
                複製
              </button>
              <button
                type="button"
                class="btn btn-lg btn-secondary"
                @click="BackList"
              >
                返回列表
              </button>
            </div>
            <div class="MbDevice">
              <button
                type="submit"
                id="cropImageBtn"
                class="btn btn-primary mr-2"
                @click="getHistData(DirectoryInfo)"
              >
                複製
              </button>
              <button type="button" class="btn btn-secondary" @click="BackList">
                返回列表
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  data() {
    return {
      isLoading: false,

      UserId: "",
      CSRF_Token: "",
      RegNo: "",
      Currentdate: "",
      directoryList: [],
      directoryEmail: [],
      directoryListDeadline: "",
      DirectoryProductLimit: 0,
      eDirectoryProductLimit: 0,
      analLogin: false, //登錄狀態
      alertSubmit: false,
      dateExpired: false,

      Directory_ComName: "",
      Directory_eComName: "",
      RegFax: "",
      RegTel: "",

      ExtraWdNum: 0, //剩餘產品字數
      eExtraWdNum: 0,

      alertMail: false,
      lang: "tw",
      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",

      openDirectory: "",

      cnWdNum: true,
      enWdNum: true,

      ExtrawordLeng: "",
      ExhibitionName: "",
      UserId: "",

      DirectoryHardcopy: false,
      DirectoryHardcopyNO: 1,
      DirectoryOrgList: [],

      AgencyNatureList: [
        { NatureName: "代理商", eNatureName: "Agent" },
        { NatureName: "總公司", eNatureName: "Principal" },
        { NatureName: "分公司", eNatureName: "Branch" },
      ],

      optionNature: "",

      analHistory: false,

      eCom_Name: "",
      eCom_Address: "",
      Com_Postalcode: "",
      Tel1: "",
      Tel2: "",
      Tel3: "",
      Com_Email: "",
      optionAgencyCountry: "",
      CountryList: [],
      optionDirectoryCountry: "",
      HisDirectoryList: [],

      CountryListCommon: [],
      CountryListOther: [],
      DirectoryOrgTotal: 0,

      isOverseas: false,

      DirectoryInfo: {},
    };
  },

  metaInfo() {
    return {
      title: "會刊登錄 - 展昭參展商管理系統",
    };
  },

  computed: {
    anaText() {
      const vm = this;

      if (vm.directoryList.ComEmail) {
        let pattern = new RegExp(
          "[`+~!#$^&*()=|{}':',\\[\\]<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？%]",
        );
        let analEmail = vm.directoryList.ComEmail.match(pattern);

        if (analEmail) {
          vm.alertMail = true;
        } else {
          vm.alertMail = false;
        }
      }
    },
  },

  methods: {
    filterField(field, e) {
      if (this.isComposing) return;
      const cleaned = e.target.value.replace(
        /[^a-zA-Z0-9 $*^!@#&()+%,./-]/g,
        "",
      );

      this[field] = cleaned;
      e.target.value = cleaned;
    },

    handleCompositionEnd(field, e) {
      this.isComposing = false;
      const cleaned = e.target.value.replace(
        /[^a-zA-Z0-9 $*^!@#&()+%,./-]/g,
        "",
      );
      this[field] = cleaned;
      e.target.value = cleaned;
    },

    submitAgency() {
      const vm = this;

      let url = `https://www.chanchao.com.tw/apiExhibitors/DirectoryOrg/Add/${vm.RegNo}`;

      const info = {
        Checked: vm.optionNature,
        Name: vm.eCom_Name,
        Address: vm.eCom_Address,
        CountryCode: vm.optionAgencyCountry,
        Postalcode: vm.Com_Postalcode,
        Tel1: vm.Tel1,
        Tel2: vm.Tel2,
        Tel3: vm.Tel3,
        Email: vm.Com_Email,
      };

      axios
        .post(url, info)
        .then((response) => {
          if (response.data.Code == 200) {
            location.reload();
          } else if (response.data.Code == 400) {
            alert("Up to 10 agencies can be added.");
          } else if (response.data.Code == 422) {
            alert("Invalid format.");
          } else if (response.data.Code == 500) {
            alert("The system is busy. Please try again later.");
          }
        })
        .catch((error) => {
          console.error("Error updating Fascia Name:", error);
        });
    },
    OpenAgencyModal() {
      if (this.DirectoryOrgTotal < 10) {
        $("#AgencyModal").modal("show");
      } else {
        alert("You can only add up to 10 agencies.");
      }
    },

    BackList() {
      $("#ShowDirectoryInfoModal").modal("hide");
      $("#CopyModal").modal("show");
    },

    OpenCopyModal() {
      const vm = this;
      $("#CopyModal").modal("show");
    },

    ShowDirectoryInfo(id) {
      $("#CopyModal").modal("hide");

      const vm = this;
      axios
        .get(`https://www.chanchao.com.tw/apiExhibitors/Directory/Detail/${id}`)
        .then((response) => {
          vm.DirectoryInfo = response.data.Data;
          $("#ShowDirectoryInfoModal").modal("show");
        });
    },
    deleteDirectoryOrg(id) {
      const vm = this;

      if (confirm("Delete this Agency?")) {
        const info = {
          CSRF: vm.CSRF_Token,
          BadgeID: id,
        };

        const url = `/apiExhibitors/DirectoryOrg/Delete/${id}`;

        axios.post(url).then(function (response) {
          if (response.data.Code == 200) {
            location.reload();
          } else if (response.data.Code == 251) {
            alert("Other conditions or sending failed");
          } else if (response.data.Code == 252) {
            alert("CSRF validation failed");
          } else if (response.data.Code == 253) {
            alert("Deletion failed");
          } else if (response.data.Code == 500) {
            alert("The system is busy. Please try again later.");
          }
        });
      } else {
        return false;
      }
    },
    getHistData(DirectoryInfo) {
      const vm = this;

      // 1. 衝突判斷：如果有資料，詢問使用者；若使用者取消，直接 return 不做任何事
      if (vm.directoryList.ComEmail) {
        if (!confirm("您的欄位已有內容，確認要執行覆蓋嗎？")) {
          return;
        }
      }

      // 2. 這裡開始是「匯入資料」與「計算邏輯」，只寫一次即可
      vm.directoryList = { ...DirectoryInfo };

      // 關閉 Modal
      $("#ShowDirectoryInfoModal").modal("hide");
      $("#CopyModal").modal("hide");
      vm.alertSubmit = true;

      // 計算中英文產品剩餘字數/限制
      const updateLimit = (limit, currentList, type) => {
        let diff = limit - currentList.length;
        if (type === "cn") {
          this.cnWdNum = diff >= 0;
          vm.ExtraWdNum = Math.abs(diff);
        } else {
          this.enWdNum = diff >= 0;
          vm.eExtraWdNum = Math.abs(diff);
        }
      };

      updateLimit(vm.DirectoryProductLimit, vm.directoryList.Product, "cn");
      updateLimit(vm.eDirectoryProductLimit, vm.directoryList.eProduct, "en");
    },

    submitform() {
      const vm = this;

      let pattern = new RegExp(
        "[`+~!#$^&*()=|{}':',\\[\\]<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？%]",
      );
      let analEmail = vm.directoryList.ComEmail.match(pattern);

      if (!analEmail) {
        vm.isLoading = true;
        if (vm.isOverseas) {
          let info = {
            CSRF: vm.CSRF_Token,
            RegNo: vm.RegNo,
            ComName: vm.Directory_ComName,
            eComName: vm.Directory_eComName,
            ComPostalCode: vm.directoryList.ComPostalcode,
            ComAddress: "",
            eComAddress: vm.directoryList.eComAddress,
            ComTel: vm.RegTel,
            ComFax: vm.RegFax,
            ComEmail: vm.directoryList.ComEmail,
            ComWebsite: vm.directoryList.ComWebsite,
            Product: "",
            eProduct: vm.directoryList.eProduct,
            CountryCode: vm.directoryList.CountryCode,
          };

          const url = `/apiExhibitors/Directory/${this.DirectoryHardcopyNO}`;
          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert("您已完成會刊登錄！");
              vm.isLoading = false;

              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/directory?no=${vm.RegNo}`;
            } else if (response.data.Code == 251) {
              alert("系統忙碌，請稍後再試！");
              vm.isLoading = false;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert("廠商/產品介紹長度不可超過 500 字數！");
              vm.isLoading = false;
            } else if (response.data.Code == 254) {
              alert("登錄已截止！");
              vm.isLoading = false;
            } else if (response.data.Code == 255) {
              alert("您輸入的Email錯誤，請重新檢查！");
              vm.isLoading = false;
            } else if (response.data.Code == 500) {
              alert("系統忙碌，請稍後再試！");
              vm.isLoading = false;
            }
          });
        } else {
          let info2 = {
            CSRF: vm.CSRF_Token,
            RegNo: vm.RegNo,
            ComName: vm.Directory_ComName,
            eComName: vm.Directory_eComName,
            ComPostalCode: vm.directoryList.ComPostalcode,
            ComAddress: vm.directoryList.ComAddress,
            eComAddress: vm.directoryList.eComAddress,
            ComTel: vm.RegTel,
            ComFax: vm.RegFax,
            ComEmail: vm.directoryList.ComEmail,
            ComWebsite: vm.directoryList.ComWebsite,
            Product: vm.directoryList.Product,
            eProduct: vm.directoryList.eProduct,
            CountryCode: vm.directoryList.CountryCode,
          };

          const url = `/apiExhibitors/Directory/${this.DirectoryHardcopyNO}`;
          axios.post(url, info2).then(function (response) {
            if (response.data.Code == 200) {
              alert("您已完成會刊登錄！");
              vm.isLoading = false;

              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/directory?no=${vm.RegNo}`;
            } else if (response.data.Code == 251) {
              alert("系統忙碌，請稍後再試！");
              vm.isLoading = false;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert("廠商/產品介紹長度不可超過 500 字數！");
              vm.isLoading = false;
            } else if (response.data.Code == 254) {
              alert("登錄已截止！");
              vm.isLoading = false;
            } else if (response.data.Code == 255) {
              alert("您輸入的Email錯誤，請重新檢查！");
              vm.isLoading = false;
            } else if (response.data.Code == 500) {
              alert("系統忙碌，請稍後再試！");
              vm.isLoading = false;
            }
          });
        }
      } else {
        if (vm.lang == "tw") {
          alert("Email欄位含有特殊字元，請重新檢查！");
        } else {
          alert("Email contains special character, please check again.");
        }
      }
    },

    countNums() {
      const vm = this;

      var txtVal = this.directoryList.Product.len();
      var AnalVal = vm.DirectoryProductLimit - txtVal;
      if (AnalVal >= 0) {
        this.cnWdNum = true;
        this.ExtraWdNum = AnalVal;
      } else {
        this.cnWdNum = false;
        this.ExtraWdNum = Math.abs(AnalVal);
      }
    },

    ecountNums() {
      const vm = this;

      var etxtVal = this.directoryList.eProduct.len();
      var eAnalVal = vm.eDirectoryProductLimit - etxtVal;

      if (eAnalVal >= 0) {
        this.enWdNum = true;
        this.eExtraWdNum = eAnalVal;
      } else {
        this.enWdNum = false;
        this.eExtraWdNum = Math.abs(eAnalVal);
      }
    },
  },

  created() {
    const vm = this;

    // $('meta[name="description"]').attr('content', newDescription)

    String.prototype.len = function () {
      return this.replace(/[^\x00-\xff]/g, "rr").length;
    };

    //語系會自動抓html lang tag

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    //取得當前時間
    let theDate = new Date();
    vm.Currentdate = `${theDate.getFullYear()}/${
      theDate.getMonth() + 1
    }/${theDate.getDate()}`;

    //參展商基本資料

    //下方是否要刪除已重複
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Directory/${vm.RegNo}`)
      .then((response) => {
        // console.log(response.data)

        vm.Directory_ComName = response.data.Data.ComName;
        vm.Directory_eComName = response.data.Data.eComName;
        vm.RegFax = response.data.Data.ComFax;
        vm.RegTel = response.data.Data.ComTel;
      });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}/?lang=${vm.lang}`,
      )
      .then((response) => {
        // console.log(response.data)
        vm.directoryListDeadline = response.data.Data.DirectoryDeadline;
        vm.DirectoryProductLimit = response.data.Data.DirectoryProductLimit;
        vm.eDirectoryProductLimit = response.data.Data.eDirectoryProductLimit;
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
        vm.openDirectory = response.data.Data.DirectoryArchived;
        vm.ExhibitionName = response.data.Data.Exhibition;

        if (response.data.Data.ExpoLocation == "O") {
          vm.isOverseas = true;
        } else {
          vm.isOverseas = false;
        }

        vm.$nextTick(() => {
          if (response.data.Data.DirectoryHardcopy == 1) {
            vm.DirectoryHardcopy = false;
            vm.DirectoryHardcopyNO = 1;

            $('[name="directoryTitle"]').text("會刊登錄");
            $('[name="directoryTitleEn"]').text("Directory Entry");
            $('[name="profileTitleEn"]').text("Basic Information");
            $('[name="homeCompanyInfo"]').text("基本資料");
            $('[name="homeDirectoryTitle"]').text("會刊登錄");
            $('[name="homeDirectoryTitleEn"]').text("Directory Entry");
            $(".HasDirectory").addClass("show");
            $(".NoDirectory").addClass("hide");
            if (vm.lang == "tw") {
              $("title").html("會刊登錄 - 展昭參展商管理系統");
            } else {
              $("title").html(
                "Directory Entry - Chan Chao Exhibitor Online Service System",
              );
            }
            //定義dateExpired是截止，當TRUE就是已截止，FALSE是未截止
            //如何沒有紙本(會刊登錄)才有截止日的限制
            if (
              Date.parse(vm.Currentdate).valueOf() >
              Date.parse(vm.directoryListDeadline).valueOf()
            ) {
              vm.dateExpired = true; //截止
            } else {
              vm.dateExpired = false; //未截止
            }
          } else {
            vm.DirectoryHardcopy = true;
            vm.DirectoryHardcopyNO = 0;

            $('[name="directoryTitle"]').text("廠商介紹");
            $('[name="directoryTitleEn"]').text("Exhibitor Profile");
            $('[name="profileTitleEn"]').text("Basic Information");
            $('[name="homeCompanyInfo"]').text("基本資料");
            $('[name="homeDirectoryTitle"]').text("廠商介紹");
            $('[name="homeDirectoryTitleEn"]').text("Exhibitor Profile");
            $(".HasDirectory").addClass("hide");
            $(".NoDirectory").addClass("show");
            if (vm.lang == "tw") {
              $("title").html("廠商介紹 - 展昭參展商管理系統");
            } else {
              $("title").html(
                "Exhibitor Profile - Chan Chao Exhibitor Online Service System",
              );
            }
          }
        });

        //判斷是否登錄，若無就取得歷史紀錄

        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/Directory/${vm.RegNo}`,
          )
          .then((response) => {
            // 使用英文版廠商/產品介紹來判定是否有登錄

            if (response.data.Data.ComEmail) {
              vm.directoryList = response.data.Data;
              vm.directoryEmail = response.data.Data.ComEmail.split(";");

              let ExtraLeng =
                vm.DirectoryProductLimit - response.data.Data.Product.len();

              if (ExtraLeng >= 0) {
                this.cnWdNum = true;
                vm.ExtraWdNum = ExtraLeng;
              } else {
                this.cnWdNum = false;
                this.ExtraWdNum = Math.abs(ExtraLeng);
              }

              let eExtraLeng =
                vm.eDirectoryProductLimit - response.data.Data.eProduct.len();

              if (eExtraLeng >= 0) {
                this.enWdNum = true;
                vm.eExtraWdNum = eExtraLeng;
              } else {
                this.enWdNum = false;
                this.eExtraWdNum = Math.abs(eExtraLeng);
              }

              vm.analLogin = true;
            } else {
              vm.analLogin = false;
            }
          });
      });

    //判斷是否有歷屆紀錄

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Directory/List/${vm.RegNo}`,
      )
      .then((response) => {
        vm.HisDirectoryList = response.data.Data;

        if (vm.HisDirectoryList && vm.HisDirectoryList.length > 0) {
          vm.analHistory = true;
        } else {
          vm.analHistory = false;
        }
      });

    //取得國家列表

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Country`)
      .then((response) => {
        // 常用國家顯示順序
        const commonCountryCodes = [
          "TW", // 台灣
          "VN", // 越南
          "CN", // 中國
          "HK", // 香港
          "KH", // 柬埔寨
          "BD", // 孟加拉
          "TH", // 泰國
          "MM", // 緬甸
          "JP", // 日本
          "KR", // 南韓
          "US", // 美國
          "SG", // 新加坡
          "MY", // 馬來西亞
        ];

        const allCountries = response.data.Data;

        // 依照 commonCountryCodes 順序產生常用國家
        vm.CountryListCommon = commonCountryCodes
          .map((code) =>
            allCountries.find((country) => country.Country_Code === code),
          )
          .filter(Boolean);

        // 其餘國家
        vm.CountryListOther = allCountries.filter(
          (country) => !commonCountryCodes.includes(country.Country_Code),
        );
      })
      .catch((error) => {
        console.error("載入國家列表失敗：", error);
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/DirectoryOrg/${vm.RegNo}`)
      .then((response) => {
        if (response.data.Code == 200) {
          vm.DirectoryOrgList = response.data.Data;
          vm.DirectoryOrgTotal = response.data.datatotal;
        } else {
          vm.DirectoryOrgTotal = 0;
        }
      });

    $(document).ready(function () {
      $(".HasDirectory").addClass("hide");
    });
  },
};
</script>

<style lang="scss">
.grayBG {
  background: #f0f4f5;
  color: #333;
  padding: 5px 10px;
  display: inline-block;
  word-break: break-all;
  font-size: 14px;
}

.hide {
  display: none;
}

.show {
  display: block;
}

.modal-body {
  overflow-y: scroll;
  max-height: 70vh;
}

.modal-header {
  background: #f3f3f3;
}

.text-info {
  color: #3c4b9f !important;
}
</style>
